import React, {Component} from 'react'
import PropTypes from 'prop-types'

class BasketQuantity extends Component {
    render() {
        const {quantity} = this.props

        return (
            <span className='BasketQuantity'>
                {quantity} {quantity > 1 ? 'items' : 'item'}
            </span>
        )
    }
}

BasketQuantity.propTypes = {
    quantity: PropTypes.string.isRequired,
}

export default BasketQuantity
